import { network } from 'services/network';

export const copyVersion = (params) => {
    return network.post('api/bo/copyVersion', params).then((response) => response.data);
};
